import * as Yup from 'yup';
import { Translation } from './translations-types';

export function useValidationSchema() {
  return Yup.object<Translation>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
